(ns manage.slate-editor.leaf
  (:require ["@mui/material/Typography$default" :as Typography]
            [common.util :refer [spread-props]]
            [uix.core :as uix :refer [$]]))

(def leaf-component-react
  (uix/as-react
   (fn leaf-component [{:keys [attributes leaf children]}]
     (cond
       ;; Not needed at the moment, but this is the right place for rendering red underlines under the text.
       #_#_(.-error leaf)
         ($ Typography (spread-props attributes
                                     {:sx (fn [^js theme]
                                            #js {:textDecoration "underline"
                                                 :textDecorationThickness "2px"
                                                 :textDecorationColor (.. theme -palette -error -main)})})
            children)

       :else
       ($ :span attributes children)))))
